import React, { Component } from "react";
import Toaster from '../components/Toaster';
import BeatLoader from 'react-spinners/BeatLoader'
import LoadingOverlay from '../common/Loader';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withRouter } from "react-router-dom";
import AllPagesPDFViewer from "../modules/dcg_viewer_pdf/all-pages";
import { api } from '../Services/index';
import getRefreshToken from '../Services/token';
const loaderStyle = {
    color: '#f3f3f3',

};
var obj = require('lodash');
var imgArr = [1, 1, 1, 1, 1, 1, 1, 1]
class AttachmentModal extends Component {


    constructor(props, context) {

        super(props, context)
        // this.apiConfig = new ApiConfig();
        this.state = {
            imgArr: [],
            url: `${api.getBaseUrl()}/dcgforms/attachments/retrieveattachmentcontent?filename=`,
            download_url: `${api.getBaseUrl()}/dcgforms/attachments/downloadattachment?filename=`
        }
    }

    toggleToaster(message, type) {
        this.setState({
            toasterMessage: message,
            toasterType: type
        })
        setTimeout(() => {
            this.setState({
                toasterMessage: null,
                toasterType: undefined
            })
        }, 2000);
    }
    componentDidMount() {
        this.getAttachmentImages(this.props.dcgId);

    }
    componentWillReceiveProps(nextProps) {
            this.getAttachmentImages(nextProps.dcgId);
    }
    componentWillUnmount = () => {
    }

    getAttachmentImages = (dcgId) => {
        this.setState({ spinnerLoading: true });
        this.setState({ imgArr: [], noData: false });
        api.getAllAttachments(dcgId)
            .then(result => {
                if (result && result.response && result.response.status == 401) {
                    this.getrefreshtoken(dcgId);
                    return;
                }
                if (result.data.attachments.length > 0) {
                    this.state.imgArr = result.data.attachments
                    let _this = this;
                    setTimeout(() => {
                        _this.setState({imgArr: _this.state.imgArr, spinnerLoading: false })
                        $('#attachmentModal').modal('show')
                    }, 700);
                } else {
                    this.setState({ spinnerLoading: false })
                    this.toggleToaster('No attachments available for the DCG.', 'warn')
                }
            }).catch((error) => {
                this.toggleToaster('Error on retrieve the attachments', 'warn');
            })
    }
    getrefreshtoken(actionPayload) {
        getRefreshToken()
            .then(res => {
                this.getAttachmentImages(actionPayload);
            })
            .catch(err => {
                this.props.history.push('/login');
            })
    }
    componentDidUpdate = () => {
    }

    close = () => {
        this.setState({ enlargeUri: null, enlargeUriType: null });        
    }

    render() {
        const { editorState } = this.state;
        return (
            <div>
                {this.state.toasterMessage ? <Toaster message={this.state.toasterMessage} toasterType={this.state.toasterType} /> : null}
                <LoadingOverlay active={this.state.spinnerLoading} spinner={<BeatLoader color={'#338bc1'}  />} className={loaderStyle} >
                    <div className="modal mt-5" id="attachmentModal" style={{ maxHeight: 700, minWidth: 800 }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Attachments</h4>
                                    {!this.state.enlargeUri && <button onClick={() => { this.close(); this.props.openAttachmentModal(false);}} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span>&times;</span>
                                    </button>}
                                </div>
                                <div className="modal-body" >
                                    <div className="row" style={{ border: '0px solid black' }}>
                                        {!this.state.enlargeUri && <div className="col-md-12" style={{ padding: 20 }}>
                                            {this.state.imgArr.map((img, index) => {
                                                return (
                                                    <div key={index} className="img-attachment" >
                                                        {img.filetype != 'pdf' ?
                                                            img.filetype == 'heic' ? (<div class="img-upload-preview-heic"><i class="fa fa-file-image"></i> </div>) :
                                                                <img src={this.state.url + '' + img.filename} onClick={() => { this.setState({ enlargeUri: (img.filename), enlargeUriType: img.filetype }); }} />
                                                            : <img src={require('../img/pdf_icons.png')} onClick={() => { this.setState({ enlargeUri: (img.filename), enlargeUriType: img.filetype }); }} />}
                                                        <a target="_blank" href={this.state.download_url + '' + img.filename}><i className="fa fa-download"></i></a>
                                                    </div>
                                                );
                                            })}
                                        </div>}
                                        {this.state.noData && <div>{'No attachment available for this dcg'}</div>}
                                        {this.state.enlargeUri && <div className="detailed-section">
                                            <div onClick={() => this.close()} >{'< Back'}</div>
                                            <a target="_blank" href={this.state.download_url + '' + this.state.enlargeUri}><i className="fa fa-download"></i></a>
                                        </div>}
                                        {this.state.enlargeUri && this.state.enlargeUriType != 'pdf' && this.state.enlargeUriType != 'heic' &&
                                            <img style={{ width: '80%', margin: 'auto' }} src={this.state.url + '' + this.state.enlargeUri} />
                                        }
                                        {this.state.enlargeUri && this.state.enlargeUriType == 'heic' &&
                                            <div class="img-upload-preview-heic"><i class="fa fa-file-image"></i> </div>
                                        }

                                        {this.state.enlargeUri && this.state.enlargeUriType == 'pdf' &&
                                            <div class="col-md-12 pdf-style">
                                                <AllPagesPDFViewer pdf={this.state.url + '' + this.state.enlargeUri} />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    {this.state.enlargeUri && <div type="button" onClick={ () => this.close() } className="btn btn-primary" >Close</div>}
                                    {!this.state.enlargeUri && <button type="button" onClick={() => { this.props.openAttachmentModal(false); }} data-dismiss="modal" className="btn btn-primary" >Close</button>}
                                </div>
                            </div>

                        </div>
                    </div >
                </LoadingOverlay>
            </div >
        );
    }
}
export default withRouter(AttachmentModal);
